// removed by extract-text-webpack-plugin
module.exports = {"root":"ResponsiveImage__root__ath9d","noImageContainer":"ResponsiveImage__noImageContainer__3ADcL","noImageWrapper":"ResponsiveImage__noImageWrapper__1Xd9O","noImageIcon":"ResponsiveImage__noImageIcon__1oU0i","noImageText":"ResponsiveImage__noImageText__3uinx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ResponsiveImage/ResponsiveImage.css
// module id = 2073
// module chunks = 0